export default __webpack_public_path__ + "static/media/img-69.b383ddab.jpg";